export const isEmailEnabled = (value: any): boolean => {
  return value === undefined || value === true || value === "true";
};